import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const CreateAccounts = ({
  id,
  isCreateAccountModalOpen,
  closeCreateAccount,
  handleCreateAccount,
}) => {
  const handleCancelButtonCLick = () => {
    closeCreateAccount();
  };

  return (
    <SlidePanel isOpen={isCreateAccountModalOpen} onClose={closeCreateAccount}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div
          onClick={closeCreateAccount}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex items-center justify-center h-full w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-full max-w-[100%] mx-auto">
            <div className="mb-10 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <div className="text-[#000000] font-bold text-[20px] ml-5">
                  <p>Create Account</p>
                </div>
              </div>

              <div className="flex items-stretch mx-5 mt-6">
                <div>
                  <svg className="h-full" width="10">
                    <rect width="10" height="100%" fill="#074073" />
                  </svg>
                </div>

                <div className="bg-[#F6FAF4] flex-grow py-2">
                  <div className="flex items-center mx-5">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.09826 19.2504H17.9033C19.3149 19.2504 20.1949 17.7195 19.4891 16.5004L12.5866 4.57453C11.8808 3.35536 10.1208 3.35536 9.41493 4.57453L2.51243 16.5004C1.8066 17.7195 2.6866 19.2504 4.09826 19.2504ZM11.0008 12.8337C10.4966 12.8337 10.0841 12.4212 10.0841 11.917V10.0837C10.0841 9.57953 10.4966 9.16703 11.0008 9.16703C11.5049 9.16703 11.9174 9.57953 11.9174 10.0837V11.917C11.9174 12.4212 11.5049 12.8337 11.0008 12.8337ZM11.9174 16.5004H10.0841V14.667H11.9174V16.5004Z"
                        fill="#AF0404"
                      />
                    </svg>

                    <div className="text-[#AF0404] text-[20px] font-[500] ml-3">
                      <p>Warning</p>
                    </div>
                  </div>

                  <div className="text-[#074073] text-[16px] font-normal mt-5 mx-5">
                    <p>
                      Before creating this account, please take a moment to
                      carefully review all the information provided. Ensure that
                      the member’s details are accurate and complete, as errors
                      may affect their records and may be difficult to correct
                      later.
                    </p>
                  </div>

                  <div className="text-[#074073] text-[16px] font-[400] mt-5 mx-5">
                    <p>
                      Confirm that you have verified all pertinent information
                      before proceeding.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center mt-8 mx-5">
                <div className="mr-5">
                  <button
                    onClick={handleCancelButtonCLick}
                    type="button"
                    className="text-[#FF5757] focus:outline-none font-[500] rounded-[5px] text-[16px] px-5 py-1.5 text-center border border-[#FF5757]"
                  >
                    No, cancel
                  </button>
                </div>

                <button
                  onClick={handleCreateAccount}
                  type="button"
                  className="text-[#FFF] bg-[#074073] hover:bg-[#074073] focus:outline-none font-[500] rounded-[5px] text-[16px] px-5 py-2 text-center"
                >
                  Yes, Create Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default CreateAccounts;
